import { IItem } from "Model/Storage/IItem";
import { IProject } from "Model/Storage/IProject";
import { IWithAddressAndName } from "Model/Storage/IWithAddressAndName";
import { hasNoElements } from "./Array";
import { ObjectWalkerCallback, walk } from "./ObjectWalker";

export function countRelevantItems(project: IProject): number {
  if (project == null) {
    return -1;
  }

  let count = 0;
  forEachRelevant(project, () => {
    count++;
    return undefined;
  });

  return count;
}

export function hasEveryRelevantProject(list: IProject[]): boolean {
  if (hasNoElements(list)) {
    return false;
  }

  return list.every((project) => project[`@isRelevant`] === true);
}

export function hasRelevantItems(project: IProject): boolean {
  return countRelevantItems(project) > 0;
}

export function getRelevantAddresses(project: IProject): IWithAddressAndName[] {
  const addresses: IWithAddressAndName[] = [];
  forEachRelevant(project, (itm) => {
    addresses.push(itm);
    return undefined;
  });
  return addresses;
}

export function forEachRelevant(project: IProject, callback: ObjectWalkerCallback<IItem>): void {
  walk<IItem>(project, `companies.contacts`, ({ "@isRelevant": isRelevant }) => isRelevant === true, callback);
}
